<template>
	<div>
		<a-table :pagination="pagination" :rowSelection="rowSelection" @change="handleTableChange" :columns="columns" :dataSource="dataSource" :loading="loading" :scroll="scroll" :bordered="border"
		:rowClassName="rowClassName">
			<template slot="format1" slot-scope="text, record">
				<slot name="format1" :record="record"></slot>
			</template>
			<template slot="format2" slot-scope="text, record">
				<slot name="format2" :record="record"></slot>
			</template>
			<template slot="format3" slot-scope="text, record">
				<slot name="format3" :record="record"></slot>
			</template>
			<template slot="format4" slot-scope="text, record">
				<slot name="format4" :record="record"></slot>
			</template>
			<template slot="format5" slot-scope="text, record">
				<slot name="format5" :record="record"></slot>
			</template>
			<template slot="format6" slot-scope="text, record">
				<slot name="format6" :record="record"></slot>
			</template>
			<template slot="action" slot-scope="text, record">
				<a-dropdown :trigger="['click']" placement="bottomCenter" overlayClassName="menu_box">
                    <a-icon class="ant-dropdown-link" type="ellipsis" style="cursor: pointer;" />
                    <a-menu slot="overlay">
						<slot :record="record"></slot>
                    </a-menu>
                </a-dropdown>
			</template>
		</a-table>
	</div>
</template>

<script>
	export default {
		name: 'CustomPage',
		props: {
			columns: {
				type: Array
			},
			url: {
				type: String,
			},
			scroll: {
				type: Object,
				defaut: {
					x: 0
				}
			},
			border:{
				type:Boolean,
				default: false
			},
			staticData:{
				type:Array,
				default: () => []
			},
			isRowSelection: {
				type: Boolean,
				default: false
			},
			selectSonData:{
				type: Array,
				default:() => []
			}
		},
		computed: {
			rowSelection: {
				get: function(){
					if(this.isRowSelection){
						return {selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange}
					}
					return null;
				},
				set: function(){

				}
			}
		},
		data() {
			return {
				loading:false,
				dataSource: this.staticData,
				pagination:{
					current:1,
					defaultCurrent:1,
					defaultPageSize:10,
					pageSize:10,
					pageSizeOptions:['10', '20', '30', '50','100','1000'],
					showQuickJumper:true,
					showSizeChanger:true,
					showTotal: (total, range) => `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`,
					total:0
				},
				params:{},
				selectedRowKeys: []
			}
		},
		methods: {
			rowClassName(record, index){
				let className;
				for(let item of this.selectSonData){
					if(item === record.key){
						className = 'choose'
					}
				}
				return className
			},
		    handleTableChange (pagination, filters, sorter) {
		    	this.resetSelectRowKeys();
		      	this.params.pageSize = pagination.pageSize;
		      	this.params.pageNum = pagination.current;
		      	if(sorter.field){
		      		this.params.sortField = sorter.field;
		      	}
		      	if(sorter.order){
		      		this.params.sortOrder = sorter.order;
		      	}
		      	this.fetch();
		    },
		    handleList({ ...params}){
		    	if(!params.pageNum && !this.params.pageNum){
		    		this.params.pageNum = this.pagination.defaultCurrent;
		    	}
		    	if(!params.pageSize && !this.params.pageSize){
		    		this.params.pageSize = this.pagination.defaultPageSize;
		    	}
		    	if(!params.sortField && !this.params.sortField){
		    		this.params.sortField = "id";
		    	}
		    	if(!params.sortOrder && !this.params.sortOrder){
		    		this.params.sortOrder = "descend";
		    	}
		    	let newParams = {};
		    	for(let i in params){
		    		if(params[i] === undefined){
		    			newParams[i] = null;
		    		}else{
		    			newParams[i] = params[i];
		    		}
		    	}
		    	for(let ele of ['pageNum','pageSize','sortField','sortOrder']){
		    		if(!newParams[ele]){
		    			delete newParams[ele]
		    		}
		    	}
		    	this.params = {
		    		...this.params,
		    		...newParams
		    	}
		    	this.fetch();
		    },
		    fetch () {
		      	this.loading = true;
		      	this.$get(this.url, this.params).then(res => {
		      		// console.log(res)
					this.pagination.total = res.data.total;
					this.pagination.pageSize = res.data.size;
					this.dataSource = res.data.rows;
					if(res.data.rows && res.data.rows.length > 0){
						this.pagination.current = this.params.pageNum;
					}else{
						this.pagination.current = this.params.pageNum - 1;
					}
			        this.loading = false;
				})
		    },
		    onSelectChange(selectedRowKeys){
		    	this.selectedRowKeys = selectedRowKeys
		    },
		    getSelectedRows(){
		    	let data = [];
		    	for (let key of this.selectedRowKeys) {
	            	data.push(this.dataSource[key])
	          	}
		    	return data;
		    },
		    resetSelectRowKeys(){
		    	this.selectedRowKeys = [];
		    }
		}
	}
</script>

<style type="text/css" lang="less" scoped>
	/deep/.ant-btn:active, .ant-btn.active{
        border-color: transparent !important;
        background-color: transparent !important;
    }
    /deep/.ant-btn{
        border-color: transparent !important;
        background-color: transparent !important;
	}
	.menu_box ul{
		text-align: center !important;
	}
	/deep/.choose{
		background-color: #EEEEEE;
	}
</style>



// WEBPACK FOOTER //
// src/views/common/CustomPage.vue